

export default function Social() {
    return (
        <div className="home__social">
            <a href="https://github.com/Bhushan1701" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-github-alt"></i>
            </a>

            {/* <a href="https://g.dev/shubhamlal" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-google"></i>
            </a> */}

            {/* <a href="https://dribbble.com/shubhamlal" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-dribbble"></i>
            </a> */}

            <a href="https://www.linkedin.com/in/bhushan-ambekar-251602144/" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-linkedin-alt"></i>
            </a>

            {/* <a href="https://stackoverflow.com/users/21035210/shubham-lal" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className='bx bxl-stack-overflow' style={{fontWeight: "700", scale: "1.25"}}></i>
            </a> */}
        </div>
    )
}